// extracted by mini-css-extract-plugin
export var copied = "social-module--copied--ac3c8";
export var hiddenInput = "social-module--hiddenInput--a9cc5";
export var icon = "social-module--icon--cc7c1";
export var icon__light = "social-module--icon__light--67aee";
export var social = "social-module--social--4d7a6";
export var social__spaced = "social-module--social__spaced--88895";
export var spin = "social-module--spin--2305a";
export var title = "social-module--title--b23ee";